// src/api/axiosInstance.ts
import axios from 'axios';

const createAxiosInstance = (baseURL: string) => {
	const instance = axios.create({
		baseURL,
		headers: {
			'Content-Type': 'application/json',
		},
	});

	instance.interceptors.request.use(
		(config) => {
			const token = localStorage.getItem('HRMS-token');
			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			}
			return config;
		},
		(error) => Promise.reject(error)
	);

	instance.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && (error.response.status === 401)) {
				localStorage.removeItem('HRMS-token');
				window.location.href = '/';
			}
			return Promise.reject(error);
		}
	);

	return instance;
};

export default createAxiosInstance;
